module.exports = __webpack_public_path__ + "static/parcel-forwarding-6d1d31d1af4486cbba8e39f33d22cc0e.jpg";